/**
 * Shopify Cart API utilities
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Add item to Shopify cart
 */
export function addToCart(variantId_1) {
    return __awaiter(this, arguments, void 0, function* (variantId, quantity = 1, properties) {
        try {
            const response = yield fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity,
                    properties: properties || {},
                }),
            });
            if (!response.ok) {
                // Check if we got HTML instead of JSON (not on Shopify domain)
                const contentType = response.headers.get('content-type');
                if (contentType && contentType.includes('text/html')) {
                    throw new Error('Cart API not available (not on Shopify domain)');
                }
                const error = yield response.json();
                throw new Error(error.description || 'Failed to add to cart');
            }
            const data = yield response.json();
            // Trigger comprehensive cart update
            yield refreshCart();
            return data;
        }
        catch (error) {
            console.error('Add to cart error:', error);
            throw error;
        }
    });
}
/**
 * Get current cart state
 */
export function getCart() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch('/cart.js');
            return yield response.json();
        }
        catch (error) {
            console.error('Get cart error:', error);
            throw error;
        }
    });
}
/**
 * Update cart item quantity
 */
export function updateCart(variantId, quantity) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity,
                }),
            });
            if (!response.ok) {
                const contentType = response.headers.get('content-type');
                if (contentType && contentType.includes('text/html')) {
                    throw new Error('Cart API not available (not on Shopify domain)');
                }
                const error = yield response.json();
                throw new Error(error.description || 'Failed to update cart');
            }
            const data = yield response.json();
            // Trigger comprehensive cart update
            yield refreshCart();
            return data;
        }
        catch (error) {
            console.error('Update cart error:', error);
            throw error;
        }
    });
}
/**
 * Clear entire cart
 */
export function clearCart() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch('/cart/clear.js', {
                method: 'POST',
            });
            if (!response.ok) {
                throw new Error('Failed to clear cart');
            }
            const data = yield response.json();
            // Trigger comprehensive cart update
            yield refreshCart();
            return data;
        }
        catch (error) {
            console.error('Clear cart error:', error);
            throw error;
        }
    });
}
/**
 * Comprehensive cart refresh - triggers all possible cart update methods
 */
export function refreshCart() {
    return __awaiter(this, void 0, void 0, function* () {
        if (typeof window === 'undefined')
            return;
        try {
            // Get latest cart data
            const cart = yield getCart();
            // 1. Update cart count in DOM (your theme uses [data-cart-count])
            const cartCountElements = document.querySelectorAll('[data-cart-count]');
            cartCountElements.forEach(element => {
                element.textContent = cart.item_count.toString();
            });
            // 2. Dispatch your theme's specific cart events
            document.dispatchEvent(new CustomEvent('theme:cart:loaded'));
            document.dispatchEvent(new CustomEvent('theme:cart:added'));
            document.dispatchEvent(new CustomEvent('theme:cart:update'));
            // 3. Refresh the cart drawer using cart-element
            const cartElement = document.querySelector('cart-element');
            if (cartElement && typeof cartElement.getCart === 'function') {
                cartElement.getCart();
            }
            // 4. Also dispatch standard Shopify events (for compatibility)
            window.dispatchEvent(new Event('cart:updated'));
            window.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cartUpdated'));
        }
        catch (error) {
            console.error('Cart refresh error:', error);
        }
    });
}
